import { MaterialDatabaseItemStateTypes, MaterialDatabaseItemActionTypes } from "./MaterialDatabaseItem.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MaterialDatabaseItemStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const MaterialDatabaseItemReducer = (
  state: MaterialDatabaseItemStateTypes = INITIAL_STATE,
  action: any
): MaterialDatabaseItemStateTypes => {
  switch (action.type) {
    case MaterialDatabaseItemActionTypes.FETCH_ALL_MATERIAL_DATABASE_ITEM:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialDatabaseItemActionTypes.FETCH_ALL_MATERIAL_DATABASE_ITEM_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialDatabaseItemActionTypes.FETCH_ALL_MATERIAL_DATABASE_ITEM_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialDatabaseItemActionTypes.FETCH_ALL_MATERIAL_DATABASE_ITEM_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case MaterialDatabaseItemActionTypes.FETCH_ONE_MATERIAL_DATABASE_ITEM:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialDatabaseItemActionTypes.FETCH_ONE_MATERIAL_DATABASE_ITEM_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialDatabaseItemActionTypes.FETCH_ONE_MATERIAL_DATABASE_ITEM_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialDatabaseItemActionTypes.FETCH_ONE_MATERIAL_DATABASE_ITEM_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MaterialDatabaseItemReducer;
